import { useMemo, useState } from 'react'
import DevolucoesPendentesTpsHttp from '../../../../services/api/https/dashboard/devolucoes-pendentes-tps.http'
import { getCompaniesGroupAssociatedToUser } from '../../../../services/api/https/system/system.http'
import { getTps, getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_INIT_INFO: 'Adquirindo Cargas Paradas',
  GET_DASHBOARD_INFO: 'Adquirindo informações . . . isso pode demorar mais tempo do que o normal',
  SAVE: 'SAVE',
  SUCCESS: 'SUCCESS',
}

const STATUS_ORDEM_COLETA = {
  CORRECAO: 'Correcao',
  APROVADO: 'Aprovado',
  FINALIZADO: 'Finalizado',
  ABERTO: 'Aberto',
}

const MODAL_NAME = {
  devolucoes_com_ordem: 'Devoluções com Ordem',
  devolucoes_sem_senha: 'Devoluções sem Senha',
  devolucoes_sem_ordem: 'Devoluções sem Ordem',
}

export const FIELDS_NAME = {
  DEVOLUCOES_COM_ORDEM: 'devolucoes_com_ordem',
  DEVOLUCOES_SEM_ORDEM: 'devolucoes_sem_ordem',
  DEVOLUCOES_SEM_SENHA: 'devolucoes_sem_senha',
}

const INITIAL_DASHBOARD_INFO = {
  devolucoes_pendentes: [],
  total_caixas: 0,
  total_entregas: 0,
  total_entregas_sem_senha: 0,
  graph_data: {
    devolucoes_totais_parcias: [],
    status_ordem_coleta: [],
  },
}

const INITIAL_STATE = {
  dashboardInfo: {
    ...INITIAL_DASHBOARD_INFO,
  },
  companyGroupSelected: null,
  modalInfo: {
    fields: [],
    data: [],
    title: '',
    show: false,
    typeModal: 'veiculos',
    width: 600,
    fieldParser: {},
    exportFileName: '',
  },
  cellColors: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}
const devolucoesFields = {
  index: '#',
  data_operacao: 'Data Operação',
  identificador: 'Identificador',
  cliente: 'Cliente',
  cidade: 'Cidade',
  bairro: 'Bairro',
  cnpj: 'CNPJ',
  qte_caixas: 'Qte. Caixas',
  qte_dias: 'Dias',
  empresa: 'Empresa',
  status: 'Status',
  senha: 'Senha',
  ordem_name: 'Ordem de Coleta',
  ordem_data: 'Data da Ordem',
}

export default function useDevolucoesPendentesTPs() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    const throwError = message => {
      setState(prevState => ({ ...prevState, errorMessage: message }))
    }

    const setModalData = (
      data,
      fields,
      show,
      title,
      width,
      fieldParser,
      expander,
      exportFileName,
    ) => {
      setState(prevState => ({
        ...prevState,
        modalInfo: {
          data: data,
          fields: Object.keys({ ...fields }),
          show: show,
          title: title,
          width: width,
          fieldParser: fieldParser,
          expander: expander,
          exportFileName: exportFileName,
        },
      }))
    }

    const generateExcelName = (modalName, tpName) => {
      return `${modalName} - ${tpName} - ${new Date().toLocaleDateString()}`
    }

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      generateColorsToGraph(name) {
        switch (name) {
          case STATUS_ORDEM_COLETA.ABERTO:
            return '#f44336'
          case STATUS_ORDEM_COLETA.APROVADO:
            return '#673ab7'
          case STATUS_ORDEM_COLETA.CORRECAO:
            return '#00bcd4'
          case STATUS_ORDEM_COLETA.FINALIZADO:
            return '#ffb74d'
          default:
            return '#323232'
        }
      },

      getCompaniesGroupAssociatedToUser() {
        getCompaniesGroupAssociatedToUser(getUsuarioInfo().id)
          .then(response =>
            setState(prevState => ({
              ...prevState,
              companiesGroups: response.map(c => ({
                label: c.company_group_name,
                value: c.company_group_id,
              })),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      getDevolucoesPendentesTps(selectedCompany, selectedTp) {
        let tpsIds = selectedTp
        if (!tpsIds) tpsIds = getTps(false).map(tp => tp.id)
        DevolucoesPendentesTpsHttp.getDevolucoesPendentesTps(selectedCompany.value, tpsIds)
          .then(dashboardInfo =>
            setState(prevState => ({
              ...prevState,
              dashboardInfo: dashboardInfo,
              cellColors: dashboardInfo.graph_data.status_ordem_coleta.map(s =>
                this.generateColorsToGraph(s.name),
              ),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onClickOpenModal(typeModal, value) {
        switch (typeModal) {
          case FIELDS_NAME.DEVOLUCOES_COM_ORDEM:
            if (value.devolucoes_com_ordem === 0) throwError('Não existem items a serem exibidos')
            else {
              const { cidade, bairro, cnpj, qte_caixas, ordem_data, ordem_name, ...fields } =
                value.modal_infos.devolucoes_com_ordem[0]
              const modalData = value.modal_infos.devolucoes_com_ordem
              setModalData(
                modalData,
                fields,
                true,
                MODAL_NAME[FIELDS_NAME.DEVOLUCOES_COM_ORDEM],
                900,
                devolucoesFields,
                true,
                generateExcelName(MODAL_NAME[FIELDS_NAME.DEVOLUCOES_COM_ORDEM], value.tp_name),
              )
            }
            break

          case FIELDS_NAME.DEVOLUCOES_SEM_ORDEM:
            if (value.devolucoes_sem_ordem === 0) throwError('Não existem items a serem exibidos')
            else {
              const {
                cidade,
                bairro,
                cnpj,
                qte_caixas,
                status,
                ordem_data,
                ordem_name,
                ...fields
              } = value.modal_infos.devolucoes_sem_ordem[0]
              const modalData = value.modal_infos.devolucoes_sem_ordem
              setModalData(
                modalData,
                fields,
                true,
                MODAL_NAME[FIELDS_NAME.DEVOLUCOES_SEM_ORDEM],
                900,
                devolucoesFields,
                true,
                generateExcelName(MODAL_NAME[FIELDS_NAME.DEVOLUCOES_SEM_ORDEM], value.tp_name),
              )
            }
            break

          case FIELDS_NAME.DEVOLUCOES_SEM_SENHA:
            if (value.devolucoes_sem_senha === 0) throwError('Não existem items a serem exibidos')
            else {
              const { cidade, bairro, cnpj, qte_caixas, ordem_data, ordem_name, ...fields } =
                value.modal_infos.devolucoes_sem_senha[0]
              const modalData = value.modal_infos.devolucoes_sem_senha
              setModalData(
                modalData,
                fields,
                true,
                MODAL_NAME[FIELDS_NAME.DEVOLUCOES_SEM_SENHA],
                900,
                devolucoesFields,
                true,
                generateExcelName(MODAL_NAME[FIELDS_NAME.DEVOLUCOES_SEM_SENHA], value.tp_name),
              )
            }
            break

          default:
            break
        }
      },

      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_INIT_INFO }))
      },

      onCompanyGroupChange(value) {
        setState(prevState => ({ ...prevState, companyGroupSelected: value }))
      },

      onBtnPesquisar(selectedCompany) {
        if (!selectedCompany)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um Grupo de Empresas' }))
        else
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_DASHBOARD_INFO }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modalInfo: { ...INITIAL_STATE.modalInfo } }))
      },
    }
  }, [])

  return { state, localDispatch }
}
